export const kAxisTickLength = 4
export const kAxisGap = 2
export const kDefaultFontHeight = 12
export const kDefaultColorSwatchHeight = 10
export const kColorAxisExtent = 14
